/**
 * @generated SignedSource<<17409dc5fb8d86fe0c1da4fc85497073>>
 * @relayHash 95166da2c54f5a2be901a28e93087d9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d93c6a1b21f7bda19aaed6d6223b73144579e74f875240d30d0f841cb45c0467

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevOpsMetricsPerIssueMetricsFilter = {
  cloudId: string;
  endAtExclusive: AGG$DateTime;
  issueFilters?: DevOpsMetricsIssueFilters | null | undefined;
  jiraProjectIds?: ReadonlyArray<string> | null | undefined;
  startFromInclusive: AGG$DateTime;
};
export type DevOpsMetricsIssueFilters = {
  epicIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  issueTypeIds?: ReadonlyArray<string> | null | undefined;
};
export type perIssueMetricsRelayQuery$variables = {
  filter: DevOpsMetricsPerIssueMetricsFilter;
  first: number;
};
export type perIssueMetricsRelayQuery$data = {
  readonly devOpsMetrics: {
    readonly perIssueMetrics: {
      readonly nodes: ReadonlyArray<{
        readonly commitsCount: number | null | undefined;
        readonly id: string;
        readonly lastSuccessfulProductionDeployment: AGG$DateTime | null | undefined;
        readonly meanReviewTimeSeconds: AGG$Long | null | undefined;
        readonly pullRequestsCount: number | null | undefined;
        readonly totalCycleTimeSeconds: AGG$Long | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type perIssueMetricsRelayQuery = {
  response: perIssueMetricsRelayQuery$data;
  variables: perIssueMetricsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "concreteType": "DevOpsMetrics",
    "kind": "LinkedField",
    "name": "devOpsMetrics",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "DevOpsMetricsPerIssueMetricsConnection",
        "kind": "LinkedField",
        "name": "perIssueMetrics",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevOpsMetricsIssueMetrics",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "totalCycleTimeSeconds"
              },
              {
                "kind": "ScalarField",
                "name": "meanReviewTimeSeconds"
              },
              {
                "kind": "ScalarField",
                "name": "commitsCount"
              },
              {
                "kind": "ScalarField",
                "name": "pullRequestsCount"
              },
              {
                "kind": "ScalarField",
                "name": "lastSuccessfulProductionDeployment"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "perIssueMetricsRelayQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "perIssueMetricsRelayQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d93c6a1b21f7bda19aaed6d6223b73144579e74f875240d30d0f841cb45c0467",
    "metadata": {},
    "name": "perIssueMetricsRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2dd0d6e3516faccec49b1afccc075495";

export default node;
